import { Button } from '@/components/button/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/card/card'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/components/form/form'
import { Input } from '@/components/input/input'

import { Header } from './ui/header'
import { useResetPasswordPage } from './use-page'

export const ResetPasswordPage = () => {
  const { form, isPendingResetPassword, handleSubmit } = useResetPasswordPage()

  return (
    <>
      <Header />
      <div className="flex flex-col space-y-6">
        <Card className="mx-auto w-[407px]">
          <CardHeader>
            <CardTitle className="leading-8">Type password</CardTitle>
            <CardDescription>Enter a new password below to change your password.</CardDescription>
          </CardHeader>

          <CardContent>
            <Form {...form}>
              <div className="grid w-full items-center gap-4">
                <form className="grid w-full items-center gap-6" onSubmit={form.handleSubmit(handleSubmit)}>
                  <FormField
                    control={form.control}
                    rules={{ required: true }}
                    name="password"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Password</FormLabel>
                        <FormControl>
                          <Input
                            className="placeholder:text-faint-foreground"
                            type="password"
                            placeholder="New password"
                            autoFocus
                            {...field}
                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                  <FormField
                    control={form.control}
                    rules={{ required: true }}
                    name="passwordConfirm"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Confirm Password</FormLabel>
                        <FormControl>
                          <Input
                            className="placeholder:text-faint-foreground"
                            type="password"
                            placeholder="Re-enter new password"
                            {...field}
                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                  {/* Submit */}
                  <Button
                    className="mb-2 w-full"
                    type="submit"
                    size="sm"
                    variant="default"
                    disabled={isPendingResetPassword}
                  >
                    Confirm password
                  </Button>
                </form>
              </div>
            </Form>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
